import {BRAND} from '@lib/brand';
import {cn} from '@lib/utils';
import {GMK_LOGO_PATH, GMK_LOGO_VIEWBOX} from './gmk-logo-path';

interface GmkLogoProps {
  /** Высота знака в px (ширина — по пропорциям 3.74:1). */
  height?: number;
  className?: string;
  /** Цвет знака; по умолчанию фирменный красный (`--brand-red`). */
  color?: string;
  title?: string;
}

/** Знак GMK (основная версия). Цвет — `currentColor`. */
export const GmkLogo = ({
  height = 20,
  className,
  color = 'var(--brand-red)',
  title = 'GMK',
}: GmkLogoProps) => (
  <svg
    viewBox={GMK_LOGO_VIEWBOX}
    height={height}
    width={(height * 1740) / 465}
    role='img'
    aria-label={title}
    className={cn('shrink-0', className)}
    style={{color}}
  >
    <path fill='currentColor' fillRule='evenodd' d={GMK_LOGO_PATH} />
  </svg>
);

interface BrandLockupProps {
  height?: number;
  className?: string;
  /** Цвет дескриптора (по брендбуку — GRAY MID2). */
  descriptorClassName?: string;
  logoColor?: string;
}

/**
 * Знак + дескриптор направления, как «GMK TEAM / GMK SALES» в брендбуке:
 * дескриптор набран акцидентным шрифтом по верхней линии знака.
 */
export const BrandLockup = ({
  height = 20,
  className,
  descriptorClassName,
  logoColor,
}: BrandLockupProps) => (
  <span className={cn('inline-flex items-start gap-[0.35em]', className)}>
    <GmkLogo height={height} color={logoColor} title={BRAND.productName} />
    <span
      className={cn(
        'font-heading uppercase leading-none tracking-[0.02em] text-[var(--brand-gray-mid2)]',
        descriptorClassName,
      )}
      style={{fontSize: height * 0.42, marginTop: height * 0.02}}
    >
      {BRAND.descriptor}
    </span>
  </span>
);
